import requestsAPI from '../../../api/access-requests'

const mapOrder = (order) => {
  switch (order) {
  case 'user':
    return 'name'
  case 'requested':
    return 'created_at'
  default:
    return 'name'
  }
}

export default {
  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID}

    if (typeof(meta.status) !== 'undefined' && meta.status !== null) {
      params.status = meta.status
    }
    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await requestsAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async approve({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'status': 'approved' }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._declinedView, value: true})
    await requestsAPI.update({tenantID, requestID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._declinedView)
  },

  async decline({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'status': 'declined' }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._declinedView, value: true})
    await requestsAPI.update({tenantID, requestID: id, data})
    dispatch('index', state._defaultView),
    dispatch('index', state._declinedView)
  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const data = { 'is_deleted': false }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._declinedView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await requestsAPI.update({tenantID, requestID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._declinedView)
    dispatch('index', state._archivedView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._declinedView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await requestsAPI.destroy({tenantID, requestID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._declinedView)
    dispatch('index', state._archivedView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/access-requests/actions.js